import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import { itineraries, kakaoInquiryUrl } from "../../data/specialTour";
import { ContentBand, Inner, PageIntro, SectionHeader, SpecialTourLayout } from "./SpecialTourLayout";

export function ItinerariesPage() {
  return (
    <SpecialTourLayout>
      <PageIntro
        eyebrow="Itineraries"
        title="기본 일정은 짧고 명확하게, 실제 일정은 팀에 맞게"
        body="날짜, 항공편, 인원, 여행 성향을 알려주시면 첫날과 마지막 날 라운드까지 다시 맞춥니다."
        image="/special-tour-assets/kagoshima-area-map.png"
      />
      <ContentBand className="bg-white">
        <Inner>
          <SectionHeader title="3박 4일 54홀 추천 일정" body="아래 일정은 상담을 시작하기 위한 기준안입니다." />
          <div className="grid gap-6">
            {itineraries.map((itinerary) => (
              <article
                id={itinerary.slug}
                key={itinerary.slug}
                className="scroll-mt-28 rounded-lg border border-[#dce3d8] bg-[#fbfaf6] p-6 shadow-sm md:p-8"
              >
                <div className="grid gap-8 lg:grid-cols-[0.85fr_1.15fr]">
                  <div>
                    <div className="text-sm font-900 text-[#d16339]">{itinerary.region}</div>
                    <h2 className="mt-2 text-3xl font-900 leading-tight text-[#15391f]">{itinerary.title}</h2>
                    <p className="mt-4 text-base leading-8 text-[#596559]">{itinerary.subtitle}</p>
                    <div className="mt-6 flex flex-wrap gap-2">
                      {itinerary.notes.map((note) => (
                        <span key={note} className="rounded-lg bg-white px-3 py-2 text-sm font-700 text-[#516052]">
                          {note}
                        </span>
                      ))}
                    </div>
                  </div>
                  <div className="grid gap-3">
                    {itinerary.days.map((day, index) => (
                      <div key={day} className="grid grid-cols-[48px_1fr] gap-4 rounded-lg bg-white p-4">
                        <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-[#e8f2e6] text-sm font-900 text-[#1e6b34]">
                          {index + 1}
                        </div>
                        <p className="self-center text-sm font-700 leading-7 text-[#344138]">{day}</p>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="mt-7">
                  <a
                    href={kakaoInquiryUrl}
                    className="inline-flex min-h-12 items-center justify-center gap-2 rounded-lg bg-[#FEE500] px-5 text-sm font-900 text-[#1b1600] transition hover:bg-[#f3db00]"
                  >
                    <ChatBubbleOutlineIcon sx={{ fontSize: 20 }} />
                    이 일정으로 카톡 문의
                  </a>
                </div>
              </article>
            ))}
          </div>
        </Inner>
      </ContentBand>
    </SpecialTourLayout>
  );
}
